
define("rv!templates/partials/halfStar",[],function(){return { v:3,
  t:[ { t:7,
      e:"img",
      a:{ alt:"half star",
        src:"https://adestinn2blob.blob.core.windows.net/images/half-star.svg" } } ] };});
